(() => {
    const TAB_BTN = '.tabs-pad .tab';
    const TAB_CONTENT = '.tab-content';
    const SWIPER_SEL = '.swiper-container.ft-step__carousel';
    const SWIPER_BUBBLE_WRAP = '.item-deco-bubble';
    const SWIPER_BUBBLE = '.bubble';
    const swiperInstances = new Map();

    const getInitialStep = (el) => parseInt(el.dataset.initialStep || '1', 10) - 1;

    const updateSlideClasses = (swiper) => {
        const activeIdx = swiper.activeIndex;
        const initialStep = getInitialStep(swiper.el);
        const isCenteredSlide = swiper.params.centeredSlides;

        if (initialStep >= 0) {
            const initialSlide = swiper.slides[initialStep];
            const link = initialSlide?.querySelector('.ft-step__link');
            link?.classList.add('is-current');
            
            if (link?.classList.contains('is-current')) {
                const target = link?.querySelector(SWIPER_BUBBLE_WRAP);
                if (target) {
                    const bubbles = target.querySelectorAll(SWIPER_BUBBLE);
                    bubbleMotion(target, [], { repeat: -1, yoyo: false });
                }
            }
        }

        swiper.slides.forEach((slide, idx) => {
            slide.classList.toggle('swiper-slide-prev', idx < activeIdx);
            slide.classList.toggle('swiper-slide-active', idx === activeIdx);
            slide.classList.toggle('hide-slide', isCenteredSlide ? idx !== activeIdx : idx < activeIdx);
        });
    };

    const initializeSwiper = (el) => {
        if (!el) return;
        if (!el.id) el.id = `swiper-${Date.now()}-${Math.random() * 1000 | 0}`;

        const key = el.id;
        const initialStep = getInitialStep(el);

        if (swiperInstances.has(key)) {
            const inst = swiperInstances.get(key);
            inst.update();
            inst.slideTo(initialStep);
            updateSlideClasses(inst);
            return;
        }

        const container = el.closest('.ft-step__content');
        const swiper = new Swiper(el, {
            initialSlide: initialStep,
            loop: false,
            slidesPerView: 2,
            spaceBetween: 0,
            centeredSlides: true,
            speed: 500,
            grabCursor: true,
            observer: true,
            observeParents: true,
            resizeObserver: true,
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            navigation: {
                prevEl: container?.querySelector('.ft-step__button-prev'),
                nextEl: container?.querySelector('.ft-step__button-next'),
            },
            breakpoints: {
                640: {
                    slidesPerView: 3,
                    centeredSlides: true,
                    slidesOffsetBefore: 0
                },
                960: {
                    slidesPerView: 4,
                    centeredSlides: false,
                    slidesOffsetBefore: container ? 100 : 0
                },
                1280: {
                    slidesPerView: 4,
                    centeredSlides: false,
                    slidesOffsetBefore: container ? 160 : 0
                }
            },
            on: {
                init: updateSlideClasses,
                slideChange: updateSlideClasses,
                breakpoint: updateSlideClasses,
                observerUpdate: updateSlideClasses
            },
        });

        swiperInstances.set(key, swiper);
    };

    const bindTabToggle = () => {
        const tabBtns = document.querySelectorAll(TAB_BTN);
        const tabContents = document.querySelectorAll(TAB_CONTENT);

        tabBtns.forEach((btn) => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                if (btn.classList.contains('is-active')) return;

                tabBtns.forEach((b) => b.classList.remove('is-active'));
                btn.classList.add('is-active');

                tabContents.forEach((c) => c.classList.remove('is-active'));

                const target = document.querySelector(btn.getAttribute('href'));
                if (target) {
                    target.classList.add('is-active');
                    const swiperEl = target.querySelector(SWIPER_SEL);
                    if (swiperEl) {
                        initializeSwiper(swiperEl);
                        setTimeout(() => {
                            const inst = swiperInstances.get(swiperEl.id);
                            inst?.update();
                            updateSlideClasses(inst);
                        }, 300);
                    }
                }
            });
        });
    };

    const initVisibleSwipers = () => {
        document
            .querySelectorAll(`${TAB_CONTENT}.is-active ${SWIPER_SEL}`)
            .forEach(initializeSwiper);
    };

    const bubbleMotion = (target, timelineArray, settings) => {
        if (!target) return;
                
        const bubbles = target.querySelectorAll(SWIPER_BUBBLE);
        const isAnimating = Array.from(bubbles).some(bubble => gsap.isTweening(bubble));
        
        if (isAnimating) {
            // console.log('bubbleMotion: animation already running, skipping...');
            return;
        }

        const defaultSettings = {
            repeat: -1,
            yoyo: false,
            ease: "none"
        };
        
        const config = Object.assign({}, defaultSettings, settings);
        
        let duration = 1.5;
        if (config.repeat === -1) {
            duration = 3;
        }
        
        const getRandomValue = () => {
            return 3 * Math.random() + 3;
        };
        
        bubbles.forEach(bubble => {
            gsap.killTweensOf(bubble);
            
            const timelines = gsap.globalTimeline.getChildren();
            timelines.forEach(timeline => {
                if (timeline.targets && timeline.targets().includes(bubble)) {
                    timeline.kill();
                }
            });
        });
        
        const container = target.closest(".item-deco");
        const containerHeight = Math.max(parseInt(container?.offsetHeight / 2) || 120, 120);
        
        for (let i = 0; i < bubbles.length; i++) {
            const bubble = bubbles[i];
            const tl = gsap.timeline(config);
            
            tl.delay(duration * i * 0.06)
                .set(bubble, {
                    x: 0,
                    y: 10,
                    scale: 0.1,
                    autoAlpha: 0
                })
                .add("wiggle")
                .to(bubble, {
                    scale: 1,
                    autoAlpha: 1,
                    duration: 0.1 * duration
                }, "wiggle")
                .to(bubble, {
                    x: 2 * getRandomValue(),
                    duration: 0.05 * duration
                }, "wiggle")
                .to(bubble, {
                    x: 2 * -getRandomValue(),
                    duration: 0.1 * duration
                })
                .to(bubble, {
                    x: 0,
                    duration: 0.05 * duration
                })
                .to(bubble, {
                    x: getRandomValue(),
                    duration: 0.07 * duration
                })
                .to(bubble, {
                    x: -getRandomValue(),
                    duration: 0.14 * duration
                })
                .to(bubble, {
                    x: 0,
                    duration: 0.07 * duration
                })
                .to(bubble, {
                    y: -containerHeight,
                    duration: 0.48 * duration
                }, "wiggle")
                .to(bubble, {
                    autoAlpha: 0,
                    scale: 0.1,
                    delay: 0.36 * duration,
                    duration: 0.12 * duration
                }, "wiggle");
            
            if (timelineArray) {
                timelineArray[i] = tl;
            }
        }
    }
    
    const init = () => {
        bindTabToggle();

        const activeBtn = document.querySelector(`${TAB_BTN}.is-active`);
        const content = activeBtn && document.querySelector(activeBtn.getAttribute('href'));
        content?.classList.add('is-active');

        document.querySelectorAll(SWIPER_SEL).forEach((swiperEl) => {
            initializeSwiper(swiperEl);


            setTimeout(() => {
                const inst = swiperInstances.get(swiperEl.id);
                inst?.update();
                updateSlideClasses(inst);
            }, 10);
        });
    };

    document.addEventListener('DOMContentLoaded', init);

    if (window.Shopify?.designMode) {
        const observer = new MutationObserver(() => setTimeout(initVisibleSwipers, 300));
        observer.observe(document.body, { childList: true, subtree: true });
    }
})();